export default {
  dailyCovers: [],
  dailyCoverInfos: {
    id: null,
    url: null,
    picture_url: null,
    activated: true,
    schedule_publish_at: null,
  },
  totalPages: 1
}
